<template>
  <CardFieldWrap
    :label="`${$t('primer.billingCode')}*`"
    :errorText="errorText"
    :statusClass="statusClass"
    @click.stop.native="$refs.postcodeInputRef && $refs.postcodeInputRef.$el.focus()"
  >
    <!-- <div
      slot="icon"
      class="question-icon"
      @click.stop="(_) => $root.Bus.$emit('showTooltips', _, $t('primer.postcodeTips'))"
    ></div> -->
    <PostcodeInput
      slot="input"
      ref="postcodeInputRef"
      class="card_input_content"
      :placeholder="$t('primer.billingAddressCode')"
      :type="userIpCountry"
      :postcode.sync="postcode"
      :showValidation="true"
      :isUpdatePostcode="false"
      @validate="handlePostcodeValidate"
      @blur="validatePostcode"
    />
  </CardFieldWrap>
</template>

<script>
import CardFieldWrap from './CardFieldWrap.vue'
import PostcodeInput from '@/components/common/form/PostcodeInput.vue'
import { POSTCODE_ERROR_TYPE } from '@/enum'
import { mapState } from 'vuex'
import { checkPostCode } from '@/api'
// import导入组件工具等
export default {
  name: 'FieldPostCode',
  components: {
    CardFieldWrap,
    PostcodeInput,
  },
  props: {
    defaultPostcode: {
      type: String,
      default: '',
    },
  },
  inject: ['updatePayinfo', 'getOrderId'],
  data() {
    return {
      postcode: '',
      errorText: '',
      statusClass: '',

      checkPendding: false,
    }
  },
  // 计算属性
  computed: {
    ...mapState({
      userIpCountry: (state) => state.user.userIpCountry,
      conutry: (state) => state.app.conutry,
      validatePostcodeMap: (state) => state.user.validatePostcodeMap,
    }),
  },
  created() {
    this.postcode = this.defaultPostcode
    this.$nextTick(() => {
      this.validatePostcode()
    })
  },
  // 组件方法
  methods: {
    // 验证邮编格式
    handlePostcodeValidate({ isValid, message, errorType }) {
      // 格式不正确
      if (!isValid) {
        // 如果长度不够或者是空，先显示 info-输入中 状态
        if (errorType !== POSTCODE_ERROR_TYPE.INVALID_FORMAT) {
          this.statusClass = 'info'
          this.errorText = ''
        } else {
          this.statusClass = 'error'
          this.errorText = message
        }
      } else {
        // 美国请求接口验证邮编合法性
        this.checkPostcodeValid()
      }
    },
    async checkPostcodeValid() {
      if (this.userIpCountry === 'CA') {
        this.setSuccessStatus()
        return true
      }
      this.checkPendding = true
      if (this.validatePostcodeMap[this.postcode] !== undefined) {
        if (this.validatePostcodeMap[this.postcode]) {
          this.setSuccessStatus()
        } else {
          this.setErrorStatus()
        }
        this.checkPendding = false
        return this.validatePostcodeMap[this.postcode]
      }
      try {
        const orderId = this.getOrderId()
        if (!orderId) return false
        const params = {
          game_id: process.env.VUE_APP_GAME_ID,
          post_code: this.postcode,
          provider_order_id: orderId,
        }
        const res = await checkPostCode(params)
        this.checkPendding = false
        if (res.data.code === 1) {
          this.setSuccessStatus()
          return true
        } else {
          this.setErrorStatus(res.data.code === 101031011)
          return false
        }
      } catch (error) {
        this.checkPendding = false
        this.setErrorStatus()
        return false
      }
    },
    setSuccessStatus() {
      this.statusClass = 'success'
      this.errorText = ''
      this.$store.commit('SET_VALIDATE_POSTCODE_MAP', { postcode: this.postcode, isValid: true })
      this.updatePayinfo({
        post_code: this.postcode,
      })
    },
    setErrorStatus(updateMap) {
      this.errorText = this.$t('code.invalid')
      this.statusClass = 'error'
      if (updateMap) {
        this.$store.commit('SET_VALIDATE_POSTCODE_MAP', { postcode: this.postcode, isValid: false })
      }
    },
    async validatePostcode() {
      if (this.checkPendding) return false
      const validateResult = this.$refs.postcodeInputRef.validatePostcode()
      if (!validateResult.isValid) {
        this.errorText = validateResult.message
        this.statusClass = 'error'
        return false
      } else {
        return await this.checkPostcodeValid()
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.question-icon {
  width: 12px;
  height: 12px;
  .bg-image('icon_question');
  margin-left: 4px;
}
</style>
